import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { UserService } from 'src/app/services/user/user.service';
import { PricingTableSubTypes } from 'src/app/shared/components/pricing-table/pricing-table.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-choose-plan',
  templateUrl: './choose-plan.component.html',
  styleUrls: ['./choose-plan.component.scss'],
})
export class ChoosePlanComponent implements OnInit{
  public user: User;
  public pricingPlans = environment.stripePlans;
  public mainPlanContent = [];
  public petName: string;
  public plan1Benefits: string[];
  public isAuthenticated: boolean;
  public membershipSelectionTitle: string;
  public isIdentiSmartTagPlanAvailable: boolean;
  public userCurrentProductType: number;
  private plan1Route: string;
  private plan2Route: string;
  private plan3Route: string;
  
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private authManager: AuthManagerService,
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.membershipSelectionTitle = this.configService.getTextFromKey('membership-selection-title')
    this.plan1Route = this.configService.getTextFromKey('1-plan-route');
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.plan3Route = this.configService.getTextFromKey('3-plan-route');
    this.plan1Benefits = this.configService.getListContentFromKey('1-plan-benefits');
    this.isIdentiSmartTagPlanAvailable = this.featureFlagService.isEnabled('isIdentiSmartTagPlanAvailable');
  }

  
  ngOnInit(): void {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
        this.userCurrentProductType = userResponse.productType;
      });
    }
  }

    public navigateToProductPage(pricingTableSubType: string): void {
      switch (pricingTableSubType) {
        case PricingTableSubTypes.IDENTIBASEPLUS:
          this._router.navigate([this.plan1Route]);
          break;
        case PricingTableSubTypes.IDENTIALERT:
          this._router.navigate([this.plan2Route]);
          break;
      }
    }

  select(planId?: string): void {
    switch (planId) {
      case environment.stripePlans.identibasePlus:
        this._router.navigate([this.plan1Route]);
        break;
      case environment.stripePlans.identiAlertMonthly:
        this._router.navigate([this.plan2Route]);
        break;
      case environment.stripePlans.identiAlertAnnual:
        this._router.navigate([this.plan2Route]);
        break;
      case environment.stripePlans.identiAlertFindCat:
        this._router.navigate([this.plan3Route]);
        break;
      case environment.stripePlans.identiAlertFind:
        this._router.navigate([this.plan3Route]);
        break;
      default:
        this._router.navigate([this.plan2Route]);
    }
  }
}
